// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, EmailAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAxvs8q1uJoOGZOhpPO4qW6dXg0f_YIw0I",
  authDomain: "pager-system-4a4ac.firebaseapp.com",
  projectId: "pager-system-4a4ac",
  storageBucket: "pager-system-4a4ac.appspot.com",
  messagingSenderId: "853600494094",
  appId: "1:853600494094:web:6bab06065cd5ee4299525f",
  measurementId: "G-QFNEDG501M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const emailProvider = new EmailAuthProvider();
export const db = getFirestore(app);
// Firebase storage reference
export const storage = getStorage(app);